import { AbgSxProps } from '@abg/typings/styling';

/**
 * Standard positioning for the Divider to snap to the bottom of a container,
 * ignoring parent padding.
 * Usage: The parent container must have 'position: relative'.
 */
export const absoluteDividerStyle: AbgSxProps = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
};
